module.exports = __webpack_public_path__ + "img/tourism_colour.314a3d19.webp";